import { cn } from "utils";

export const LoadingState = ({
  count = 2,
  className,
}: {
  count?: number;
  className?: string;
}) => (
  <div className={cn("grid gap-3 grid-cols-2", className)}>
    {Array.from({ length: count }).map((_, index) => (
      <div
        key={index}
        className="flex gap-2 p-4 bg-background_white_overlay5 rounded-lg items-center"
      >
        <div className="w-4 h-4 rounded bg-background_white_overlay10 animate-pulse" />
        <div className="h-8 w-8 rounded-full bg-background_white_overlay10 animate-pulse" />
        <div className="flex flex-col gap-2">
          <div className="h-[14px] w-[70px] rounded-1 bg-background_white_overlay10 animate-pulse" />
          <div className="h-[14px] w-[154px] rounded-1 bg-background_white_overlay10 animate-pulse" />
        </div>
      </div>
    ))}
  </div>
);
